import { ReactNode, useState } from 'react'
import styled from 'styled-components'
import PopUp from '../pop-up'
import Button from './button'

const Dropdown = styled.div`
    position: relative;
`

type Props = {
    className?: string
    preview?: ReactNode
    label?: ReactNode
    children?: ReactNode
    popUpColor?: string
}

const CreationToolsDropdown = ({ className, preview, label, children, popUpColor }: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    return (
        <Dropdown className={className}>
            <Button
                {...{
                    label,
                    preview,
                    onClick: () => setIsOpen(true),
                }}
            />
            {isOpen && (
                <PopUp
                    {...{
                        arrowPosition: 'right',
                        backgroundColor: popUpColor,
                        onClose: () => setIsOpen(false),
                    }}
                >
                    {children}
                </PopUp>
            )}
        </Dropdown>
    )
}

export default CreationToolsDropdown
